import { Deserializable } from '../deserializable';
import { AgentDto } from './agent-dto.model';
import { CaseAdministratorRightDto } from './case-administrator-right-dto.model';

export class BusinessWriterDto extends AgentDto implements Deserializable {
  public Roles: Array<CaseAdministratorRightDto>;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.Roles = input.Roles.map((caseAdministratorRightDto: CaseAdministratorRightDto) =>
      new CaseAdministratorRightDto().deserialize(caseAdministratorRightDto)
    );

    return this;
  }
}
